import { createMiddleware } from '../redux';
import { SHOW_ERROR_TOAST_MESSAGE, SHOW_SUCCESS_TOAST_MESSAGE, SHOW_WARNING_TOAST_MESSAGE } from './toasts.state';
import { showToast, TOAST_TYPE } from '../components/messages-and-errors/ToastsNotifications';

export const toastMiddleWares = createMiddleware({
    [SHOW_ERROR_TOAST_MESSAGE]: (state, action) => {
        // TODO: https://github.com/paretogroup/quantic-spa/issues/545
        handleShowToast(action, TOAST_TYPE.ERROR);
    },
    [SHOW_SUCCESS_TOAST_MESSAGE]: (state, action) => {
        handleShowToast(action, TOAST_TYPE.SUCCESS);
    },
    [SHOW_WARNING_TOAST_MESSAGE]: (state, action) => {
        handleShowToast(action, TOAST_TYPE.WARNING);
    },
});

const handleShowToast = (action, toastType) => showToast(
    action.payload.message,
    toastType,
    action.payload.options,
    action.payload.component,
    action.payload.link,
);
